export default __webpack_public_path__ + "static/media/claude-ai.aaaadc32.svg";